__turbopack_context__.v({
  "blocksBackgroundColor": "VideoBlock-module-scss-module__yUvOTa__blocksBackgroundColor",
  "blocksFontColor": "VideoBlock-module-scss-module__yUvOTa__blocksFontColor",
  "embedResponsive": "VideoBlock-module-scss-module__yUvOTa__embedResponsive",
  "embedResponsive16by9": "VideoBlock-module-scss-module__yUvOTa__embedResponsive16by9",
  "embedResponsive4by3": "VideoBlock-module-scss-module__yUvOTa__embedResponsive4by3",
  "embedResponsiveItem": "VideoBlock-module-scss-module__yUvOTa__embedResponsiveItem",
  "secondaryNavBackgroundColor": "VideoBlock-module-scss-module__yUvOTa__secondaryNavBackgroundColor",
  "themeBackgroundColor": "VideoBlock-module-scss-module__yUvOTa__themeBackgroundColor",
  "themeFontColor": "VideoBlock-module-scss-module__yUvOTa__themeFontColor",
  "themeFontFamily": "VideoBlock-module-scss-module__yUvOTa__themeFontFamily",
});
